import React, { FunctionComponent } from 'react'
import capitalize from 'lodash/capitalize'

import { NavLink } from 'react-router-dom'

import { displayEllipsisWithMaxChar } from '../../../helpers/displayFormatHelper'

interface Item {
  id: string
  description: string
  typeName: string
  url: string
}

export interface Props {
  id: string
  items: Item[]
  type: string
}

export const Documents: FunctionComponent<Props> = ({ id, items, type }) => {
  return (
    <div className="documents">
      <div className="documents__header">DOCUMENTS</div>
      {type === 'refi' && (
        <NavLink to={`/refinance/${id}/uploaddocument`}>
          <div className="documents__upload">
            <button type="button">Upload Document</button>
          </div>
        </NavLink>
      )}
      <div className="documents__items">
        {items
          ? items.map((item, i) => {
              return (
                <div key={i} className="documents__row">
                  <div className="documents__row--title">
                    {item.description
                      ? displayEllipsisWithMaxChar(item.description, 20)
                      : capitalize(item.typeName)}
                  </div>
                  <div className="documents__row--buttons">
                    <a href={item.url} target="_blank">
                      Print
                    </a>{' '}
                    <a href={item.url} target="_blank">
                      Download
                    </a>
                  </div>
                </div>
              )
            })
          : null}
      </div>
    </div>
  )
}

Documents.displayName = 'Documents'
